import { render } from "./IndexFour.vue?vue&type=template&id=2a8bd022"
import script from "./IndexFour.vue?vue&type=script&lang=js"
export * from "./IndexFour.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__